module.exports = __webpack_public_path__ + "static/surface-studio-8c74b51ebc94e083436330df92a06954.png";